export default {"src":"/_next/static/media/WarnigSignRed.032b58d9.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};